module.exports = __webpack_public_path__ + "static/media/Pad.2b2de1e1.png";